/**
 * Input formatters for form fields.
 * They strip anything that isn't a digit, then add separators as the user types.
 */

// 2395551234 -> 239-555-1234
export const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// 1250000 -> 1,250,000
export const formatWithCommas = (value) => {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  return Number(digits).toLocaleString('en-US');
};

// Picks the right formatter from the field name, so forms can share one handler.
// Phone fields get dashes; price, amount, rent, income, loan, and footage fields get commas.
export const formatFieldValue = (name, value) => {
  if (typeof value !== 'string') return value;
  if (/phone/i.test(name)) return formatPhone(value);
  if (/(price|amount|footage|income|rent|loan|budget)/i.test(name) && !/percent/i.test(name)) {
    return formatWithCommas(value);
  }
  return value;
};
